import React, { useMemo, useRef, useState, useCallback } from 'react';
import CommonGrid from '../../../../../common/GridWithHeader/CommonGrid';
import GridConfig from './GridConfig';
import ShipmentMovement from './ShipmentMovement';

const UsageDetails = ({ data, selectedTerminal, userData }) => {
  const gridConfig = useRef(new GridConfig({ userConfig: userData.userProfile?.columnPref }));
  const [shipmentMovementState, setShipmentMovementState] = useState({
    isOpen: false,
    rowData: null
  });

  const filteredData = useMemo(() => {
    return selectedTerminal ? data.filter((item) => item.terminalCode === selectedTerminal) : data;
  }, [data, selectedTerminal]);

  const handleShipmentMovementToggle = useCallback((event) => {
    const rowData = event?.data;
    if (rowData) {
      setShipmentMovementState({ isOpen: true, rowData });
    } else {
      setShipmentMovementState({ isOpen: false, rowData: null });
    }
  }, []);

  return (
    <>
      <CommonGrid
        title="Details By Date"
        data={filteredData}
        exportFileName="usage_of_dynamic_routing_details_by_date"
        config={gridConfig.current.config}
        onRowDoubleClicked={handleShipmentMovementToggle}
        gridHeaderConfig={{
          showFullscreen: false
        }}
      />
      {shipmentMovementState.isOpen && (
        <ShipmentMovement
          open={shipmentMovementState.isOpen}
          onClose={handleShipmentMovementToggle}
          rowData={shipmentMovementState.rowData}
        />
      )}
    </>
  );
};

export default UsageDetails;
